import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// const GenXSCommon = require("../../utils/XhsXsCommonEnc.js") as (a1cookie: string, x_t: string|number, x_s:string) => string;

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface searchXhsMentionsParams extends ActiomCommonParams {
    num: number;
    cursor: string | null;
}

export interface MentionsResponse {
    code: number;
    success: boolean;
    msg: string;
    data: MentionsDetail;
}

export interface MentionsDetail {
    message_list: {
        title: string;
        time: number;
        comment_info: {
            illegal_info: {
                status: number;
                desc: string;
                illegal_status: string;
            };
            status: number;
            liked: boolean;
            like_count: number;
            id: string;
            content: string;
        };
        type: string;
        score: number;
        user_info: {
            userid: string;
            nickname: string;
            image: string;
            red_official_verify_type: number;
            xsec_token: string;
        };
        item_info: {
            type: string;
            content: string;
            image_info: {
                width: number;
                height: number;
                url: string;
            };
            status: number;
            id: string;
            image: string;
            illegal_info: {
                status: number;
                desc: string;
                illegal_status: string;
            };
            link: string;
            user_info: {
                userid: string;
                nickname: string;
                image: string;
                red_official_verify_type: number;
            };
            xsec_token: string;
        };
        track_type: string;
        liked: boolean;
        time_flag: number;
        id: string;
    }[];
    has_more: boolean;
    strCursor: string;
}

export type PublishAction = CommonAction<searchXhsMentionsParams, MentionsDetail | Record<string, unknown>>;

export const searchXhsWebMentions: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(0, "获取评论成功", { message_list: [], has_more: false, strCursor: "" });
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: {} };

    const mentionsParams = {
        num: params.num ?? 20,
        cursor: params.cursor ?? "",
    };
    const fatchMentions = "/api/sns/web/v1/you/mentions";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const fatchMentionsXsHeader = xsEncrypt.signHeadersGet(fatchMentions, recordCookie, "xhs-pc-web", mentionsParams);

    // const xscommon = GenXSCommon(a1Cookie, xt, xs)
    const res = await http.api<MentionsResponse>(
        {
            method: "get",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/you/mentions",
            params: mentionsParams,
            headers: fatchMentionsXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );
    const isSuccess = res.code === 0;
    const message = `获取评论${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data : {};

    return response(isSuccess ? 0 : 414, message, data);
};
